export const round = n => Math.round(n * 100) / 100;

export default {
  round,
};



// WEBPACK FOOTER //
// ./src/utils/math.js